const dragonsCommonNote = require('./dragons_common')

module.exports = [
  {
    text: `Барды иногда ищут логова латунных драконов в надежде, что причуды драконов повысят их творческий потенциал, подобно музе. Более опытные барды знают, что нельзя злоупотреблять гостеприимством, иначе можно проснуться в бочке прокисшей капусты.`,
    author: `Физбан`,
  },
  ...dragonsCommonNote,
]
